const UNIX_MILLISECONDS_THRESHOLD = 100_000_000_000;

const taipeiFormatter = new Intl.DateTimeFormat("zh-TW", {
  timeZone: "Asia/Taipei",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h23",
});

export function toEpochMilliseconds(value: number): number {
  return Math.abs(value) < UNIX_MILLISECONDS_THRESHOLD ? value * 1_000 : value;
}

export function formatTaipeiDateTime(value: number): string {
  const parts = Object.fromEntries(
    taipeiFormatter.formatToParts(new Date(toEpochMilliseconds(value)))
      .filter((part) => part.type !== "literal")
      .map((part) => [part.type, part.value]),
  );
  return `${parts.month}/${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`;
}
